import Vue from 'vue';

    import { isRms } from './conditions_cem.js'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    

export const conditions_new = [
  {
    label: $t('7fb6ad'),
    value: 'eq',
    type: 1,
    tag: 'or',
    valueAs: 'in',
    label_encode: '%E9%80%89%E6%8B%A9',
    label_en: 'Select',
  },
  {
    label: $t('2cdd97'),
    value: 'neq',
    type: 1,
    tag: 'and',
    valueAs: 'nin',
    label_encode: '%E6%9C%AA%E9%80%89%E6%8B%A9',
    label_en: 'Unselected',
  },
  {
    label: $t('3580ac'),
    value: 'contain',
    type: 1,
    tag: 'or',
    valueAs: 'contain',
    label_encode: '%E5%8C%85%E5%90%AB',
    label_en: 'Include',
  },
  {
    label: $t('f3828f'),
    value: 'zdy',
    type: 3,
    tag: 'and',
    valueAs: 'contain',
    label_encode: '%E8%87%AA%E5%AE%9A%E4%B9%89',
    label_en: 'Customize ',
  },
  {
    label: $t('488005'),
    value: 'eq',
    type: 2,
    tag: 'or',
    valueAs: 'in',
    label_encode: '%E7%AD%89%E4%BA%8E',
    label_en: 'Equiv. to',
  },
  {
    label: $t('ece43e'),
    value: 'neq',
    type: 2,
    tag: 'and',
    valueAs: 'nin',
    label_encode: '%E4%B8%8D%E7%AD%89%E4%BA%8E',
    label_en: 'Not equal',
  },
  {
    label: $t('9c83fb'),
    value: 'gt',
    type: 2,
    tag: 'and',
    valueAs: 'gt',
    label_encode: '%E5%A4%A7%E4%BA%8E',
    label_en: 'Gt',
  },
  {
    label: $t('948773'),
    value: 'gte',
    type: 2,
    tag: 'and',
    valueAs: 'gte',
    label_encode: '%E5%A4%A7%E4%BA%8E%E7%AD%89%E4%BA%8E',
    label_en: 'Greater than or equal',
  },
  {
    label: $t('d60a3f'),
    value: 'lt',
    type: 2,
    tag: 'and',
    valueAs: 'lt',
    label_encode: '%E5%B0%8F%E4%BA%8E',
    label_en: 'Less than',
  },
  {
    label: $t('489409'),
    value: 'lte',
    type: 2,
    tag: 'and',
    valueAs: 'lte',
    label_encode: '%E5%B0%8F%E4%BA%8E%E7%AD%89%E4%BA%8E',
    label_en: 'Less than/equal to',
  },
  {
    label: $t('25cfec'),
    value: 'between',
    type: 2,
    tag: 'contain',
    valueAs: 'contain',
    label_encode: '%E4%BB%8B%E4%BA%8E',
    label_en: 'Between',
  },
  {
    label: $t('47f6c2'),
    value: 'keyword',
    type: 10,
    tag: 'in',
    valueAs: 'in',
    label_encode: '%E5%85%B3%E9%94%AE%E8%AF%8D',
    label_en: 'Keywords ',
  },
  {
    label: $t('e5556a'),
    value: 'emotional',
    type: 11,
    tag: 'or',
    valueAs: 'eq',
    label_encode: '%E6%83%85%E6%84%9F',
    label_en: 'Emotion ',
  },
  {
    label: $t('4350ef'),
    value: 'complaint',
    type: 12,
    tag: 'eq',
    valueAs: 'eq',
    label_encode: '%E5%AE%A2%E8%AF%89',
    label_en: 'Complaint',
  },
  {
    label: $t('d63a96'),
    value: 'voice_sentiment_category',
    type: 13,
    tag: 'eq',
    valueAs: 'eq',
    label_encode: '%E6%83%85%E7%BB%AA',
    label_en: 'Emotion',
  },
  {
    label: $t('b48960'),
    value: 'alert_level',
    type: 12,
    tag: 'eq',
    valueAs: 'eq',
    mark_id: 18,
    label_encode: '%E9%A2%84%E8%AD%A6%E7%AD%89%E7%BA%A7',
    label_en: 'Warning level',
  },
  {
    // 触发次数大于
    label: decodeURIComponent('%E8%A7%A6%E5%8F%91%E6%AC%A1%E6%95%B0%E5%A4%A7%E4%BA%8E'),
    value: 'history_same_label_count',
    type: 14,
    tag: 'gt',
    valueAs: 'gt',
    label_encode: '%E8%A7%A6%E5%8F%91%E6%AC%A1%E6%95%B0%E5%A4%A7%E4%BA%8E',
    label_en: 'Same label count greater than',
  },
]
export const conditions = [
  {
    label: $t('7fb6ad'),
    value: 'eq',
    type: 1,
    tag: 'or',
  },
  {
    label: $t('2cdd97'),
    value: 'neq',
    type: 1,
    tag: 'and',
  },
  {
    label: $t('3580ac'),
    value: 'contain',
    type: 1,
    processType: false,
    tag: 'or',
  },
  // 日期
  {
    label: $t('f3828f'),
    value: 'zdy',
    type: 3,
    tag: 'and',
  },
  {
    label: $t('25cfec'),
    value: 'between',
    type: 3,
    tag: 'and',
  },
  {
    label: $t('948773'),
    value: 'gte',
    type: 3,
    tag: 'and',
  },
  {
    label: $t('489409'),
    value: 'lte',
    type: 3,
    tag: 'and',
  },
  {
    label: $t('488005'),
    value: 'eq',
    type: 2,
    tag: 'or',
  },
  {
    label: $t('ece43e'),
    value: 'neq',
    type: 2,
    tag: 'and',
  },
  {
    label: $t('9c83fb'),
    value: 'gt',
    type: 2,
    tag: 'and',
  },
  {
    label: $t('948773'),
    value: 'gte',
    type: 2,
    tag: 'and',
  },
  {
    label: $t('d60a3f'),
    value: 'lt',
    type: 2,
    tag: 'and',
  },
  {
    label: $t('489409'),
    value: 'lte',
    type: 2,
    tag: 'and',
  },
]
export const operatorList = [
  {
    value: 'GT',
    label: $t('9c83fb'),
  },
  {
    value: 'GTE',
    label: $t('948773'),
  },
  {
    value: 'LT',
    label: $t('d60a3f'),
  },
  {
    value: 'LTE',
    label: $t('489409'),
  },
  {
    value: 'EQ',
    label: $t('488005'),
  },
  {
    value: 'BETWEEN',
    label: $t('25cfec'),
  },
]
// 情感
export const emotional = [
  {
    value: '',
    label: $t('16853b'),
  },
  {
    value: 'positive',
    label: $t('0e1638'),
  },
  {
    value: 'neutral',
    label: $t('2eb100'),
  },
  {
    value: 'bad',
    label: $t('56c5de'),
  },
]
// 数据类型
export const dataType = [
  {
    key: 'type-0',
    value: 0,
    label: $t('e4b3ae'),
  },
  {
    key: 'type-1',
    value: 1,
    label: $t('5f382f'),
  },
  {
    key: 'type-3',
    value: 3,
    label: $t('1e2fff'),
  },
  {
    key: 'type-2',
    value: 2,
    label: $t('2c480b'),
  },
  {
    key: 'type-4',
    value: 4,
    label: $t('64b151'),
  },
  {
    key: 'type-5',
    value: 5,
    label: $t('4d39e5'),
  },
  {
    key: 'type-6',
    value: 6,
    label: $t('8bd364'),
  },
  {
    key: 'type-7',
    value: 7,
    label: $t('081a57'),
  },
]

export const getDataSourceType = (authMap, filterType) => {
  let list = dataType.filter(item => {
    if ([6, 7].includes(item.value)) {
      return false
    }
    return true
  })

  if (authMap['ACTION-COMMENT-GROUP-DETAIL']) {
    list.push({
      key: 'BI-COMMENT-DATASOURCE',
      value: 'BI-COMMENT-DATASOURCE',
      label: $t('d3307a'),
    })
  }
  if (filterType) list = list.filter(item => item.key !== filterType)

  return VocDeepClone.deepClone(list)
}
export const sourceType = {
  3: $t('1e2fff'),
  1: $t('5f382f'),
  2: $t('2c480b'),
  4: $t('64b151'),
  5: $t('4d39e5'),
  6: $t('8bd364'),
  7: $t('081a57'),
}

export const opersType = [
  {
    value: 'and',
    label: $t('16853b'),
  },
  {
    value: 'or',
    label: $t('22cfbe'),
  },
]

export const warningRuleStatus = [
  {
    value: -1,
    label: $t('16853b'),
  },
  {
    value: 0,
    label: $t('ba4d99'),
  },
  {
    value: 1,
    label: $t('572fbe'),
  },
]

export const models = [
  {
    value: 1,
    label: isRms() ? 'RMS' : $t('cc43ce'),
  },
  // {
  //   value: 2,
  //   label: "模型"
  // }
]

export const statusName = { 1: $t('889b3e'), 0: $t('4551d4') }
export const statusColor = { 1: '#B8C1D0', 0: '#73C03F' }
export const statusText = { 0: $t('ba4d99'), 1: $t('572fbe') }
export const taskMap = [
  {
    value: -1,
    label: $t('16853b'),
  },
  {
    value: 2,
    label: $t('2d13b6'),
  },
  {
    value: 1,
    label: $t('d939d4'),
  },
  {
    value: 3,
    label: $t('8b9b30'),
  },
  {
    value: 4,
    label: $t('af2d33'),
  },
  {
    value: 10,
    label: $t('ce764b'),
  },
]

export const displayContent = {
  pie_doughnut: $t('82604b'),
  indicator_card: $t('fa1284'),
  gauge: $t('2744f6'),
  columnar: $t('3bdef9'),
  columnar_stack: $t('825c59'),
  columnar_stack_line: $t('ee0b03'),
  bar: $t('517686'),
  bar_stack: $t('5a69f1'),
  bar_stack_line: $t('a9670a'),
  broken_line: $t('e9524f'),
  table: $t('104709'),
  area: $t('c77a88'),
  pie: $t('67905b'),
  dict: $t('72f988'),
  box: $t('ebdc11'),
  thematic_analysis: $t('afe02c'),
  scatter: $t('ed7d53'),
  text_analysis: $t('a24421'),
  radar: $t('d92e42'),
  // 内容
  same: $t('6168b8'),
  sequential: $t('56afdf'),
  mentions_top_10: $t('7de931'), // --1
  nps_top_10: $t('7da9c0'), // --1
  nps_reciprocal_10: $t('c5f7d1'), // --1
  mention_rate: $t('200987'), // --2
  nps_change_rate: $t('f2033d'), // --2
  emotional_changes_rate: $t('335350'), // --2
  comment_change: $t('644629'),
  comment_reciprocal_5: $t('5c42b7'),
  emotional_reciprocal_5: $t('de5ca3'),
  mentions_top_5: $t('d2bcbe'),
  satisfaction_top_5: $t('97e4b0'),
  satisfaction_reciprocal_5: $t('a8b8d1'),
  vnps: 'NPS Pro',
  nps: 'NPS',
  mentions: $t('9b4263'),
  positive: $t('9b9e0f'),
  neutral: $t('db8a78'),
  negative: $t('cb2919'),
  supportContentTypeExclusive: [],
  supportChartTypeList: [],
}

export const typeList = { 1: $t('380da9'), 2: $t('5d819c'), 3: $t('43a358'), 4: $t('aea420') }
export const typeName = { 1: 'T', 2: '#', 3: 'D', 4: '♬' }
export const typeNumber = { T: 1, '#': 2, D: 3, '♬': 4 }
export const typeColor = { T: '#50bc7a', '#': '#fea50a', D: '#67a7eb', '♬': '#C55253' }
export const fieldTypeList = [
  {
    value: 'T',
    label: $t('380da9'),
  },
  {
    value: 'D',
    label: $t('43a358'),
  },
  {
    value: '#',
    label: $t('5d819c'),
  },
  {
    value: '♬',
    label: $t('aea420'),
  },
]
export const taskWayList = [
  {
    value: 2,
    label: $t('55658e'),
  },
  {
    value: 1,
    label: $t('394eb6'),
  },
  {
    value: 4,
    label: $t('67fa03'),
  },
  {
    value: 10,
    label: $t('0bcf8e'),
  },
  {
    value: 6,
    label: $t('390169'),
  },
  {
    value: 3,
    label: $t('07f55b'),
  },
]

export const notifyWayConfig = { 3: $t('8b9b30'), 4: $t('65fe67'), 6: $t('e0a806'), 12: $t('2a6876') }

export const operationList = [
  {
    type: 'editor',
    name: $t('6267f3'),
  },
  {
    type: 'enable',
    name: $t('889b3e'),
  },
  {
    type: 'disable',
    name: $t('4551d4'),
  },
  {
    type: 'copy',
    name: $t('29f67f'),
  },
  {
    type: 'delete',
    name: $t('e33c9b'),
  },
]

export const robotType = {
  1: $t('cd551e'),
  2: $t('3c1847'),
  3: $t('e7149f'),
}

// 字段下拉内容配置
export const fieldOpersConfiguration = [
  {
    value: '1',
    label: $t('a31fb3'),
    children: [],
  },
  {
    value: '2',
    label: $t('0fa5f4'),
    children: [],
  },
  // {
  //   value: "2",
  //   label: "高级计算",
  //   children: []
  // },
  // {
  //   value: "3",
  //   label: "排名",
  //   children: []
  // },
  // {
  //   value: "4",
  //   label: "数据可见范围",
  //   children: []
  // },
  // {
  //   value: "5",
  //   label: "数值格式",
  //   children: []
  // },
]

// 参考线值类型
export const lineValueType = { int: true, percent: false }
// 任务频率
export const taskFrequency = [
  {
    value: 0,
    label: $t('90b251'),
  },
  {
    value: 60,
    label: $t('7fc898'),
  },
  {
    value: 3600,
    label: $t('e15c1d'),
  },
  {
    value: 7200,
    label: $t('2be514'),
  },
  {
    value: 21600,
    label: $t('2a7c5c'),
  },
  {
    value: 43200,
    label: $t('85852b'),
  },
  {
    value: 86400,
    label: $t('9329be'),
  },
]
// 优先级
export const priorityList = [
  {
    value: 10,
    label: $t('c052e0'),
  },
  {
    value: 20,
    label: $t('317039'),
  },
  {
    value: 30,
    label: $t('93c9ea'),
  },
  {
    value: 40,
    label: $t('5f2f41'),
  },
]
// 解决时长
export const sloveList = [
  {
    value: 300,
    label: $t('e399d2'),
  },
  {
    value: 600,
    label: $t('2b44ce'),
  },
  {
    value: 900,
    label: $t('d07c2f'),
  },
  {
    value: 1800,
    label: $t('7b0809'),
  },
  {
    value: 3600,
    label: $t('bd4dad'),
  },
  {
    value: 7200,
    label: $t('c44d6a'),
  },
  {
    value: 28800,
    label: $t('df81e7'),
  },
  {
    value: 43200,
    label: $t('bc5b47'),
  },
  {
    value: 53200,
    label: $t('9593fc'),
  },
]
// 预警规则升级时间
export const upgradeTimeList = [
  {
    value: 300,
    label: $t('e399d2'),
  },
  {
    value: 600,
    label: $t('2b44ce'),
  },
  {
    value: 900,
    label: $t('d07c2f'),
  },
  {
    value: 1800,
    label: $t('7b0809'),
  },
]
// 监控周期
export const taskMonitoringPeriod = [
  {
    value: 'zdy',
    label: $t('f3828f'),
  },
  {
    value: 'day',
    label: $t('fadfae'),
  },
  {
    value: 'week',
    label: $t('2c4f7d'),
  },
  {
    value: 'month',
    label: $t('c232ab'),
  },
  {
    value: 'quarter',
    label: $t('827d3b'),
  },
  {
    value: 'year',
    label: $t('5d4c76'),
  },
]
export const recordColors = { positive: '#00b6b6', bad: '#DC6583', neutral: '#909399' }
// 图表只支持NPS数字或是百分比
export const nps_mutex = ['columnar', 'bar', 'columnar_stack', 'bar_stack', 'radar']

/*
{
  // 数据源列ID
  columnId: 'TJUEIWPGNDSOPGNTEOWPJTOI',
  // 数据列名称
  columnName: '',
  // 类型'percent'|'number'|'text' (text类型的暂时无法设置颜色,需要先过滤)
  columnType: '', 
  // 关联的显示内容
  contentTypeKeyList: ['nps', 'same']
  // 颜色配置
  colorsConfig: [
    {
      // 选择的颜色
      color: '',
      // GT: 大于 GTE: 大于等于 LT: 小于 LTE: 小于等于 EQ: 等于 BETWEEN: 介于
      calculate: 'GT',
      // value数组,如果是介于则数组长度为2
      value: [10],
    }
    // more...
  ]
},
*/

// 默认颜色
export const defaultColor = [
  {
    color: '#31BFBF',
    calculate: 'GT',
    value: [0],
  },
  {
    color: '#EE6E6E',
    calculate: 'LT',
    value: [0],
  },
]

// 指标统计 biModelId: comment_score_coreq_detail
export const comment_score_coreq_detail = [
  {
    columnName: 'NPS Pro',
    columnId: 'sen_rate',
    columnIdAs: 'sen_rate',
    columnType: 'percent',
    contentTypeKeyList: ['vnps'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('f79aa5'),
    columnId: 'pos_rate',
    columnIdAs: 'pos_rate',
    columnType: 'percent',
    contentTypeKeyList: ['vnps'],
    colorsConfig: [],
  },
  {
    columnName: $t('6b03ca'),
    columnId: 'neg_rate',
    columnIdAs: 'neg_rate',
    columnType: 'percent',
    contentTypeKeyList: ['vnps'],
    colorsConfig: [],
  },
  {
    columnName: $t('9b4263'),
    columnId: 'hit_count',
    columnIdAs: 'hit_count',
    columnType: 'number',
    contentTypeKeyList: ['mentions'],
    colorsConfig: [],
  },
  {
    columnName: $t('1ce20e'),
    columnId: 'hit_rate',
    columnIdAs: 'hit_rate',
    columnType: 'percent',
    contentTypeKeyList: ['mentions'],
    colorsConfig: [],
  },
  {
    columnName: $t('9b9e0f'),
    columnId: 'pos_count',
    columnIdAs: 'pos_count',
    columnType: 'number',
    contentTypeKeyList: ['positive'],
    colorsConfig: [],
  },
  {
    columnName: $t('780621'),
    columnId: 'pos_hit_rate',
    columnIdAs: 'pos_hit_rate',
    columnType: 'percent',
    contentTypeKeyList: ['positive'],
    colorsConfig: [],
  },
  {
    columnName: $t('db8a78'),
    columnId: 'neu_count',
    columnIdAs: 'neu_count',
    columnType: 'number',
    contentTypeKeyList: ['neutral'],
    colorsConfig: [],
  },
  {
    columnName: $t('43d161'),
    columnId: 'neu_hit_rate',
    columnIdAs: 'neu_hit_rate',
    columnType: 'percent',
    contentTypeKeyList: ['neutral'],
    colorsConfig: [],
  },
  {
    columnName: $t('cb2919'),
    columnId: 'neg_count',
    columnIdAs: 'neg_count',
    columnType: 'number',
    contentTypeKeyList: ['negative'],
    colorsConfig: [],
  },
  {
    columnName: $t('bc5f4c'),
    columnId: 'neg_hit_rate',
    columnIdAs: 'neg_hit_rate',
    columnType: 'percent',
    contentTypeKeyList: ['negative'],
    colorsConfig: [
      {
        color: '#EE6E6E',
        calculate: 'GT',
        value: [0],
      },
    ],
  },
]

// 指标NPS统计 biModelId: nps_text_coreq_detail
export const nps_text_coreq_detail = [
  {
    columnName: 'NPS',
    columnId: 'nps_rate',
    columnIdAs: 'nps_rate',
    columnType: 'percent',
    contentTypeKeyList: ['nps'],
    colorsConfig: [],
  },
  {
    columnName: $t('6168b8'),
    columnId: 'nps_rate_tbd',
    columnIdAs: 'nps_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('56afdf'),
    columnId: 'nps_rate_hbd',
    columnIdAs: 'nps_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'sequential'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('4f388f'),
    columnId: 'influence_rate',
    columnIdAs: 'influence_rate',
    columnType: 'percent',
    contentTypeKeyList: ['influence_rate'],
    colorsConfig: [],
  },
  {
    columnName: $t('aa75c6'),
    columnId: 'influence_rate_tbd',
    columnIdAs: 'influence_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['influence_rate', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('8b8504'),
    columnId: 'influence_rate_hbd',
    columnIdAs: 'influence_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['influence_rate', 'sequential'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('e2be25'),
    columnId: 'good_rate',
    columnIdAs: 'good_rate',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'positive'],
    colorsConfig: [],
  },
  {
    columnName: $t('3e1783'),
    columnId: 'good_rate_tbd',
    columnIdAs: 'good_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'positive', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('bbe38a'),
    columnId: 'good_rate_hbd',
    columnIdAs: 'good_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'positive', 'sequential'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('bb2044'),
    columnId: 'bad_rate',
    columnIdAs: 'bad_rate',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'negative'],
    colorsConfig: [
      {
        color: '#EE6E6E',
        calculate: 'GT',
        value: [0],
      },
    ],
  },
  {
    columnName: $t('1d5d70'),
    columnId: 'bad_rate_tbd',
    columnIdAs: 'bad_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'negative', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('33c0da'),
    columnId: 'bad_rate_hbd',
    columnIdAs: 'bad_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'negative', 'sequential'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('9b4263'),
    columnId: 'hit_count',
    columnIdAs: 'hit_count',
    columnType: 'number',
    contentTypeKeyList: ['mentions'],
    colorsConfig: [],
  },
  {
    columnName: $t('1ce20e'),
    columnId: 'hit_rate',
    columnIdAs: 'hit_rate',
    columnType: 'percent',
    contentTypeKeyList: ['mentions'],
    colorsConfig: [],
  },
  {
    columnName: $t('8c4c34'),
    columnId: 'hit_rate_tbd',
    columnIdAs: 'hit_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['mentions', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('7034e1'),
    columnId: 'hit_rate_hbd',
    columnIdAs: 'hit_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['mentions', 'sequential'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('9b9e0f'),
    columnId: 'pos_count',
    columnIdAs: 'pos_count',
    columnType: 'number',
    contentTypeKeyList: ['positive'],
    colorsConfig: [],
  },
  {
    columnName: $t('780621'),
    columnId: 'pos_rate',
    columnIdAs: 'pos_rate',
    columnType: 'percent',
    contentTypeKeyList: ['positive'],
    colorsConfig: [],
  },
  {
    columnName: $t('a3e215'),
    columnId: 'pos_rate_tbd',
    columnIdAs: 'pos_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['positive', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('39c7ca'),
    columnId: 'pos_rate_hbd',
    columnIdAs: 'pos_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['positive', 'sequential'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('db8a78'),
    columnId: 'neu_count',
    columnIdAs: 'neu_count',
    columnType: 'number',
    contentTypeKeyList: ['neutral'],
    colorsConfig: [],
  },
  {
    columnName: $t('43d161'),
    columnId: 'neu_rate',
    columnIdAs: 'neu_rate',
    columnType: 'percent',
    contentTypeKeyList: ['neutral'],
    colorsConfig: [],
  },
  {
    columnName: $t('05cd88'),
    columnId: 'neu_rate_tbd',
    columnIdAs: 'neu_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['neutral', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('8683c7'),
    columnId: 'neu_rate_hbd',
    columnIdAs: 'neu_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['neutral', 'sequential'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('cb2919'),
    columnId: 'neg_count',
    columnIdAs: 'neg_count',
    columnType: 'number',
    contentTypeKeyList: ['negative'],
    colorsConfig: [],
  },
  {
    columnName: $t('bc5f4c'),
    columnId: 'neg_rate',
    columnIdAs: 'neg_rate',
    columnType: 'percent',
    contentTypeKeyList: ['negative'],
    colorsConfig: [
      {
        color: '#EE6E6E',
        calculate: 'GT',
        value: [0],
      },
    ],
  },
  {
    columnName: $t('44ee3b'),
    columnId: 'neg_rate_tbd',
    columnIdAs: 'neg_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['negative', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: $t('ce2f63'),
    columnId: 'neg_rate_hbd',
    columnIdAs: 'neg_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['negative', 'same'],
    colorsConfig: defaultColor,
  },
]

export const predefineColors = ['#33BFBF', '#598EE7', '#F4C943', '#FF7D51', '#975AD0', '#49BCE8', '#EE6E6E']

export const countWay = [
  {
    calculateId: 'count',
    describe: $t('85ee09'),
    name: $t('85ee09'),
    presetConfig: {
      valueType: 'number',
    },
  },
  {
    calculateId: 'distinct',
    describe: $t('520cfb'),
    name: $t('520cfb'),
    presetConfig: {
      valueType: 'number',
    },
  },
  {
    calculateId: 'sum',
    describe: $t('2176c8'),
    name: $t('2176c8'),
    presetConfig: {
      valueType: 'number',
    },
  },
  {
    calculateId: 'avg',
    describe: $t('ac3dc0'),
    name: $t('ac3dc0'),
    presetConfig: {
      valueType: 'number',
    },
  },
  {
    calculateId: 'max',
    describe: $t('1114a5'),
    name: $t('1114a5'),
    presetConfig: {
      valueType: 'number',
    },
  },
  {
    calculateId: 'min',
    describe: $t('84724d'),
    name: $t('84724d'),
    presetConfig: {
      valueType: 'number',
    },
  },
  {
    calculateId: 'stddev',
    describe: $t('edf22a'),
    name: $t('edf22a'),
    presetConfig: {
      valueType: 'number',
    },
  },
  {
    calculateId: 'nps',
    describe: 'NPS',
    name: 'NPS',
    presetConfig: {
      valueType: 'percent',
    },
  },
  {
    calculateId: 'survey_score_percent',
    name: $t('869791'),
    describe: $t('869791'),
    presetConfig: {
      // 预设配置
      valueType: 'percent', // 百分比
    },
  },
  {
    calculateId: 'survey_question_score_percent',
    name: $t('90b89a'),
    describe: $t('90b89a'),
    presetConfig: {
      // 预设配置
      valueType: 'percent', // 百分比
    },
  },
  {
    calculateId: 'survey_calculate_avg_score_percent',
    name: $t('d67d2e'),
    describe: $t('f09288'),
    presetConfig: {
      // 预设配置
      valueType: 'percent', // 百分比
    },
  },
]

export const complaintType = [
  {
    value: 'S',
    label: $t('645fd2'),
  },
  {
    value: 'A',
    label: $t('cdfca0'),
  },
  {
    value: 'B',
    label: $t('8feb3e'),
  },
  {
    value: 'C',
    label: $t('9f49f4'),
  },
]

export const complaintType_EN = [
  {
    value: 'S',
    label: 'Class S (High-risk/severe events)',
  },
  {
    value: 'A',
    label: 'Class A(High negative review risk)',
  },
  {
    value: 'B',
    label: 'Class B(Medium negative review risk)',
  },
  {
    value: 'C',
    label: 'Class C(Users complain events)',
  },
]
